import {FC} from "react";

const Firm: FC = () => {
    return (
        <div className="Firm">
            <h1>Firm</h1>
            <p>Firm content goes here.</p>
        </div>
    );
}

export default Firm;